import { Switch } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import LoginPage from "../pages/login";
import SignupPage from "../pages/signup";
import { Route } from "./routes";

export const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={LoginPage} isPublic={false} />
      <Route exact path="/signup" component={SignupPage} isPublic={false} />
      <Route exact path="/dashboard" component={Dashboard} isPrivate={true} />
    </Switch>
  );
};
